export default __webpack_public_path__ + "maps-examples-custom-style-thumbnail-960-c241c249af7e1c82ba3b3b5a54493096.png";